import React, { ReactElement } from "react";
import { ListTableColumn, createListTableColumns, ensure, Stack, TableColumn } from "sprint-common-web";

import { convertTimestampToTimestring } from "../../../../../../../../common/utils/convertTimestampToTimestring";
import { Environment } from "../../../../../../../../core/types/Environment";
import { OverwriteSegmentButton } from "../overwrite/buttons/OverwriteSegmentButton";
import { RekognitionResultItem } from "./RekognitionResultItem";

export const createRekognitionResultListingColumns = (
    environment: Environment
): ListTableColumn<RekognitionResultItem>[] => {
    const columns = [
        {
            type: "basic",
            key: "type",
            name: "Type",
            minWidth: 100,
            maxWidth: 100,
            isSortable: true
        },
        {
            type: "basic",
            key: "confidence",
            name: "Confidence",
            minWidth: 80,
            maxWidth: 80,
            onRender: renderConfidence
        },
        {
            type: "basic",
            key: "startTimestamp",
            name: "Start",
            minWidth: 100,
            maxWidth: 100,
            onRender: renderFormattedTime,
            isSortable: true
        },
        {
            type: "basic",
            key: "endTimestamp",
            name: "End",
            minWidth: 100,
            maxWidth: 100,
            onRender: renderFormattedTime,
            isSortable: true
        }
    ] as TableColumn<RekognitionResultItem>[];

    if (environment !== Environment.Prod) {
        columns.push({
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 50,
            maxWidth: 50,
            buttons: [
                {
                    id: "overwriteSegment",
                    getItemId: (item) => item.key,
                    render: OverwriteSegmentButton
                }
            ]
        });
    }
    return createListTableColumns<RekognitionResultItem>(columns);
};

const renderFormattedTime = (
    item?: RekognitionResultItem,
    _index?: number,
    column?: ListTableColumn<RekognitionResultItem>
): ReactElement | null => {
    ensure(item);
    ensure(column);

    let formattedTime = "-";

    if (column.key === "startTimestamp" || column.key === "endTimestamp") {
        formattedTime = convertTimestampToTimestring(item[column.key]);
    }

    return <Stack>{formattedTime}</Stack>;
};

const renderConfidence = (item?: RekognitionResultItem) => {
    return <Stack>{item?.confidence ?? 0}%</Stack>;
};
